import React, { useCallback } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { TravelDetails as TravelDetailsModel } from 'models/travelDetails';
import { getFormattedPrice } from 'utils/currency';
import { expirationHours } from 'utils/generic';

import TagPricesDetail from '../TagPricesDetail';
import { Container, Title, Total, Header, Division, TextCol } from './styles';

interface Props {
  data: TravelDetailsModel;
}

const Prices = ({ data }: Props) => {
  const { t } = useStoreTranslation();
  const formattedPrice = (value: number | undefined, currency: string) => {
    const { formatted } = getFormattedPrice({ value, currency, t });
    return formatted;
  };

  const { air, hotel, requester, prices, alternativePrices, vehicle } = data;

  const returnExpirationDate = () =>
    air ? air?.expirationDate : hotel ? hotel.expirationDate : vehicle ? new Date(vehicle.expirationDate) : new Date();

  const getExpiration = useCallback((date: Date) => expirationHours(date), []);

  return (
    <Container>
      <Header>
        <TextCol>
          <Title>{t('travelDetails.prices.title')}</Title>
          {air
            ? '1 ' + t('travelDetails.prices.adult')
            : vehicle
            ? t('travelDetails.prices.daily_plural', { count: vehicle.quantityDays })
            : t('travelDetails.prices.nights', { count: hotel?.quantityDays })}
        </TextCol>
        <TagPricesDetail status={requester.status} time={getExpiration(returnExpirationDate())} />
      </Header>
      <Division />
      <Total>
        <Total.Area>
          <Total.Text>{t('travelDetails.prices.totalValue')}</Total.Text>
          <Total.Value>{formattedPrice(prices.total, data.prices.currencyCode)}
            {
              alternativePrices && alternativePrices.total > 0 && (
                <>
                  <br />&nbsp;{t('alternativePrice.or')}&nbsp; 
                  {formattedPrice(alternativePrices.total, alternativePrices.currencyCode)}
                </>                
              )}
          </Total.Value>
        </Total.Area>
      </Total>
    </Container>
  );
};

export default Prices;
